import api from '@/services/api'

export default {
  state: {
    isLoggedInEthosTickets: !!localStorage.getItem('tokenEthosTickets'),
    userEthosTickets: {
      name: '',
    },
    onlyProjectsActive: true,
  },

  mutations: {
    AUTH(state, user) {
      state.isLoggedInEthosTickets = true
      state.userEthosTickets = {
        name: user.name,
      }
    },

    CHANGE_PROJECTS_ACTIVE(state) {
      state.onlyProjectsActive = !state.onlyProjectsActive
    },

    LOGOUT(state) {
      state.isLoggedInEthosTickets = false
      state.userEthosTickets = {
        name: '',
      }
    },
  },

  actions: {
    async getMicrosoftLink({ commit }) {
      try {
        const response = await api.get('/auth/sign-in-microsoft/link')
        return response && response.data ? response.data : null
      } catch (error) {
        commit('LOGOUT')
        throw error
      }
    },

    async signInMicrosoft({ commit }, code) {
      try {
        const response = await api.post('/auth/sign-in-microsoft/code', code)

        const data = response && response.data ? response.data : null
        const token = data && data.token ? data.token : ''

        const user = {
          name: data && data.user ? data.user.name : '',
        }

        localStorage.setItem('tokenEthosTickets', token)
        commit('AUTH', user)
      } catch (error) {
        commit('LOGOUT')
        throw error
      }
    },

    changeProjectActive({ commit }) {
      commit('CHANGE_PROJECTS_ACTIVE')
    },

    logout: ({ commit }) => {
      commit('LOGOUT')
    },
  },

  getters: {
    isLoggedInEthosTickets: (state) => state.isLoggedInEthosTickets,
    user: (state) => state.userEthosTickets,
    onlyProjectsActive: (state) => state.onlyProjectsActive,
  },
}
